{
  "closeMonth": {
    "title": "Close the month",
    "prepayHint": "Prepay this month's schedule, reconciling last month's attendance",
    "sessions": "sessions",
    "adjust": "Adjustment",
    "flatFee": "Monthly flat fee",
    "pending": "{{count}} session(s) not yet marked",
    "summary": "{{payers}} invoices · {{amount}}",
    "generate": "Create {{count}} draft invoices",
    "generating": "Creating...",
    "empty": "No unbilled sessions this month",
    "emptyMaybeStale": "Nothing left to close this month — the enrollment you were sent here for already has a period for it. The warning on {{from}} will remain: that stranded period cannot be settled from this screen.",
    "done": "Created {{count}} draft invoices",
    "open": "Close the month",
    "reopen": "Reopen period",
    "reopenSuccess": "Reopened {{month}}",
    "reopenBlocked": "Can't reopen: an invoice has been sent/paid. Please handle it first.",
    "reopenHistoryTitle": "Reopen history",
    "reopenHistoryItem": "Reopened {{month}} · {{count}} draft invoice(s) deleted",
    "cancel": "Cancel",
    "selectAll": "Select all",
    "selectPayer": "Select {{name}}",
    "staleOpenItem": "{{student}} ({{client}}) — close {{month}} to reconcile",
    "staleOpenItemUnbilled": "{{student}} ({{client}}) — {{count}} session(s) in {{month}} were never billed. Close {{month}} first.",
    "staleOpenMore": "and {{count}} more",
    "staleOpenGoto": "Switch to {{month}}",
    "backToInvoices": "Back to invoices",
    "willCreate": "Invoices to be created",
    "pendingChip": "This total may change once attendance is marked",
    "noneSelected": "Select at least one payer to create invoices",
    "footerAriaLabel": "Summary of the invoices to be created",
    "footerNote": "Creates draft invoices — you review them before sending",
    "gridTitle": "Reconciling {{month}} attendance",
    "gridHint": "A ? cell is an un-marked session — click it to mark attendance fast",
    "reopenHistoryDesc": "Every reopen of a period is recorded here.",
    "reopenHistoryEmpty": "No period has been reopened yet.",
    "guidance": {
      "title": "Before you close",
      "countLabel": "{{count}} to review",
      "pendingTitle": "{{count}} session(s) in {{prev}} are still un-marked",
      "pendingDesc": "Close now and those {{count}} session(s) will not be reconciled into any invoice",
      "pendingAction": "Mark attendance now",
      "staleTitle": "{{month}} is still open for {{names}}",
      "staleDesc": "Closing {{current}} first means {{month}} will never be reconciled — close the oldest month first",
      "staleNamesMore": "{{names}} and {{count}} more",
      "staleMonthsMore": "and {{count}} more month(s) still open",
      "staleDetails": "See details",
      "quotaTitle": "{{remaining}} auto-reconcile credit(s) left this month",
      "quotaDesc": "You are about to create {{payerCount}} invoices — the excess will need manual reconciliation",
      "quotaAction": "Upgrade"
    },
    "confirmDialog": {
      "title": "Confirm invoice creation",
      "description": "This will create {{count}} draft invoices · Total {{amount}}.",
      "dueDateToggle": "Customize due date",
      "dueDateLabel": "Due date",
      "dueDatePast": "The due date must be today or later.",
      "saveDefault": "Save this date as the default for future closes",
      "saveDefaultDayTooHigh": "Only days 1–28 can be saved as the default — this date still applies to this run.",
      "confirm": "Confirm",
      "confirming": "Creating..."
    },
    "reopenPicker": {
      "title": "Select payers to reopen",
      "description": "{{month}} will be reopened for the payers you select below.",
      "warningDraftsLost": "The selected payers' draft invoices will be permanently deleted, including any hand edits.",
      "warningPerPayer": "Each row is one invoice (or one payer, for a credit-only period) — it covers every child billed on it.",
      "warningRecloseSelected": "Once you're done editing, close the month again and tick only these payers.",
      "noInvoice": "— no invoice",
      "blockedPending": "Sent — cannot reopen",
      "blockedPaid": "Paid — cannot reopen",
      "blockedSuccessor": "A later period already closed against this one — cannot reopen",
      "blockedOther": "No longer a draft — cannot reopen",
      "confirm": "Reopen {{count}} item(s)",
      "confirming": "Reopening...",
      "empty": "Nothing to reopen this month",
      "genericError": "Couldn't reopen. Please try again."
    },
    "reopenHistoryAll": "View the whole activity log"
  }
}
